import { useRef, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "./App.scss";
import { LiveAPIProvider } from "./contexts/LiveAPIContext";
import { InterviewAssistant } from "./components/interview/Interview";
import ResumeUpload from "./components/resume-upload/ResumeUpload";
import FacilitatorReport from "./components/facilitator-report/FacilitatorReport";
import { StudyCompanion } from "./components/study-companion/StudyCompanion";
import ControlTray from "./components/control-tray/ControlTray";
import cn from "classnames";
import CoursePage from "./components/course/CoursePage";
import Dashboard from "./components/dashboard/Dashboard";
import ConsoleHeader from "./components/ConsoleHeader";

const API_KEY = process.env.REACT_APP_GEMINI_API_KEY || "";

const host = "generativelanguage.googleapis.com";
const uri = `wss://${host}/ws/google.ai.generativelanguage.v1beta.GenerativeService.BidiGenerateContent`;

function App() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [videoStream, setVideoStream] = useState<MediaStream | null>(null);

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route
            path="/course"
            element={
              <div className="streaming-console shell-static">
                <ConsoleHeader />
                <div className="console-body">
                  <main style={{ overflow: "hidden", height: "100%" }}>
                    <div
                      className="main-app-area"
                      style={{ height: "100%", padding: 0 }}
                    >
                      <CoursePage />
                    </div>
                  </main>
                </div>
              </div>
            }
          />
          <Route
            path="/facilitator/report"
            element={
              <div className="streaming-console shell-static">
                <ConsoleHeader />
                <div className="console-body">
                  <main>
                    <div className="main-app-area">
                      <FacilitatorReport />
                    </div>
                  </main>
                </div>
              </div>
            }
          />
          <Route
            path="*"
            element={
              <LiveAPIProvider url={uri} apiKey={API_KEY}>
                <div className="streaming-console">
                  <ConsoleHeader />
                  <div className="console-body">
                    <main>
                      <div className="main-app-area">
                        <Routes>
                          <Route path="/study" element={<StudyCompanion />} />
                          <Route path="/facilitator" element={<ResumeUpload />} />
                          <Route
                            path="/facilitator/session"
                            element={<InterviewAssistant />}
                          />
                          <Route
                            path="/resupload"
                            element={<Navigate to="/facilitator" replace />}
                          />
                          <Route
                            path="/interview"
                            element={<Navigate to="/facilitator/session" replace />}
                          />
                          <Route
                            path="/dsa"
                            element={<Navigate to="/" replace />}
                          />
                          <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                        <video
                          className={cn("stream", {
                            hidden: !videoRef.current || !videoStream,
                          })}
                          ref={videoRef}
                          autoPlay
                          playsInline
                        />
                      </div>

                      <ControlTray
                        videoRef={videoRef}
                        supportsVideo={true}
                        onVideoStreamChange={setVideoStream}
                      />
                    </main>
                  </div>
                </div>
              </LiveAPIProvider>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
